import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TimeLineEventOverlayButton } from "./timelineevent.styled.jsx";
import { TimelineEventApprove } from "../icons.jsx";
import { useTranslation } from "react-i18next";

export const ApproveButton = ({ approveEvent }) => {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      placement="top-end"
      overlay={
        <Tooltip id="button-tooltip-2" style={{ position: "fixed" }}>
          {t("Approve", "Hyväksy")}
        </Tooltip>
      }
    >
      <TimeLineEventOverlayButton $action="approve" onClick={approveEvent}>
        <TimelineEventApprove />
      </TimeLineEventOverlayButton>
    </OverlayTrigger>
  );
};
